// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"i4-z","colorTextValue":"j4-z","swatches":"k4-z","collapseLink":"l4-z","isCollapsed":"m4-z","dropdown":"n4-z","disabled":"o4-z"};